import script from "./Success.vue?vue&type=script&setup=true&lang=js"
export * from "./Success.vue?vue&type=script&setup=true&lang=js"

import "./Success.vue?vue&type=style&index=0&id=738c06fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-738c06fc"]])

export default __exports__